import React from 'react';
import { useTranslation } from 'react-i18next';
import './style.css'

const Contactpage = () => {
    const { t } = useTranslation();
    return(
        <div id="Contact" className="contact-area section-padding">
            <div className="container">
                <div className="wpo-contact-info">
                    <div className="row">
                        <div className="col-lg-4 col-md-6 col-sm-12 col-12">
                            <div className="info-item">
                                <div className="info-wrap">
                                    <div className="info-icon">
                                        <i className="fi flaticon-internet"></i>
                                    </div>
                                    <div className="info-text">
                                        <span>{t('contact.office_address')}</span>
                                    </div>
                                </div>
                                <h2>{t('footer.address')}</h2>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6 col-sm-12 col-12">
                            <div className="info-item">
                                <div className="info-wrap">
                                    <div className="info-icon">
                                        <i className="fi flaticon-email"></i>
                                    </div>
                                    <div className="info-text">
                                        <span>{t('contact.office_email')}</span>
                                    </div>
                                </div>
                                <h2>info@thairoute.com</h2>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6 col-sm-12 col-12">
                            <div className="info-item">
                                <div className="info-wrap">
                                    <div className="info-icon">
                                        <i className="fi flaticon-null-1"></i>
                                    </div>
                                    <div className="info-text">
                                        <span>{t('contact.office_phone')}</span>
                                    </div>
                                </div>
                                <h2>02-269-6999</h2>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
     )
}

export default Contactpage;
